import {useState} from "react";

export const useInputNumberHook = (initValue?:string):[value:string, handle:(value:string)=> void] =>{
    const [valor, setValor] = useState(initValue===undefined?'':initValue);

    const handleInputChange = (value:string) => {
        if (!isNaN(Number(value))) {
            setValor(value);
        }
    };

    return [valor, handleInputChange]
}